<div fxLayout="column">

  <app-page-header [banner]="false" [section]="'Leasing history'" [title]="'Look over your lease schedule'" [description]="'This is your lease schedule summarising the lease terms of each lease categorised according to the current lease status.'"></app-page-header>

  <app-leasing-schedule></app-leasing-schedule>

</div>
